import { render, staticRenderFns } from "./workRule.vue?vue&type=template&id=5c06d703&scoped=true&"
import script from "./workRule.vue?vue&type=script&lang=js&"
export * from "./workRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c06d703",
  null
  
)

export default component.exports